import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView } from '@cer/cer-form/cer-form-view';
import { FieldWidthEnum } from 'src/cer/cer-data/cer-data-types';

export class RefDataNemHandelsRegisterForm extends CerFormAdapter {

  override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'ref-data-nem-handels-register', dataApiName: 'RefData_NemHandelsRegister', text: 'NemHandelsregister',
        primaryKey: 'id', allowEdit: false, allowCreate: false, allowDelete: false
      },
      fieldMetadata: [
        { name: 'id', text: 'Nøgle', format: 'Text', visible: false, widthType: FieldWidthEnum.M },
        { name: 'keyType', text: 'Addressetype', format: 'Text', widthType: FieldWidthEnum.XXS },
        { name: 'key', text: 'GLN/CVR Adresse', format: 'Text', widthType: FieldWidthEnum.XS },
        { name: 'unitName', text: 'Navn', format: 'Text', widthType: FieldWidthEnum.XXXL },
        { name: 'unitCVR', text: 'CVR nr.', format: 'Text', widthType: FieldWidthEnum.XXS }
      ]

    });
  }
}
